export const DISCOUNT_FORMAT_ENUM = {
  PERCENTAGE: 'percentage',
  MONEY: 'money'
}

export const isPercentageFormat = value => value.toLowerCase() === DISCOUNT_FORMAT_ENUM.PERCENTAGE.toLowerCase()
export const isMoneyFormat = value => value.toLowerCase() === DISCOUNT_FORMAT_ENUM.MONEY.toLowerCase()
